import React from "react";

function ResidencyHighlights(props) {

    return (
        <>
            <aside className="highlights">
                <div className="highlights-title-container text-center d-flex justify-content-between">
                    <div className="highlights-title">
                        <h4>Highlights</h4>
                    </div>
                    <img src="/images/highlights.png" className="highlights-logo"></img>
                </div>
                <div className="widget-body">

                    <div className="booktext">
                        <ul className="highlights-list">
                            <li className="highlights-list-item">
                                Unlimited use of CAMP facilities - indoor and outdoor work/performance spaces, music production gear, field recording gear, AV setups, art/making equipment and much more
                            </li>
                            <li className="highlights-list-item">
                                Explore the mountains, forests, lakes and plateaus of the beautiful Pyrenees Ariegoises
                            </li>
                            <li className="highlights-list-item">
                                Take time out from daily life, dedicate some time to think, write, and create.
                            </li>
                        </ul>
                    </div>

                </div>
            </aside>
        </>
    );
}

export default ResidencyHighlights;

